var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_832_818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0.5C4.3125 0.5 3.75 1.0625 3.75 1.75V19.25C3.75 19.9375 4.3125 20.5 5 20.5H17.5C18.1875 20.5 18.75 19.9375 18.75 19.25V5.5L13.75 0.5H5Z",
    fill: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5.5H18.75L13.75 0.5V4.25C13.75 4.9375 14.3125 5.5 15 5.5Z",
    fill: "#B0B7BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 9.25L15 5.5H18.75V9.25Z",
    fill: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 16.75C16.25 17.0938 15.9688 17.375 15.625 17.375H1.875C1.53125 17.375 1.25 17.0938 1.25 16.75V10.5C1.25 10.1562 1.53125 9.875 1.875 9.875H15.625C15.9688 9.875 16.25 10.1562 16.25 10.5V16.75Z",
    fill: "#A066AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.62561 12.3419C3.62561 12.1769 3.75499 11.9962 3.96499 11.9962H5.11999C5.76936 11.9962 6.35436 12.4312 6.35436 13.2656C6.35436 14.0556 5.76936 14.495 5.11999 14.495H4.28436V15.155C4.28436 15.3756 4.14561 15.5 3.96499 15.5C3.79999 15.5 3.62561 15.3756 3.62561 15.155V12.3419ZM4.28436 12.6262V13.8706H5.11936C5.45374 13.8706 5.71873 13.5756 5.71873 13.2656C5.71873 12.9156 5.45374 12.6262 5.11936 12.6262H4.28436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99123 12.3919C6.99123 12.2112 7.03123 12.0369 7.29123 12.0369C7.4706 12.0369 7.51123 12.0819 7.6456 12.2112L9.29935 14.2806V12.3419C9.29935 12.1769 9.44373 11.9962 9.61435 11.9962C9.79435 11.9962 9.96873 12.1769 9.96873 12.3419V15.155C9.96873 15.3756 9.83373 15.4594 9.70373 15.5C9.52935 15.5 9.44373 15.46 9.29935 15.3256L7.6456 13.2262V15.1556C7.6456 15.3762 7.5106 15.5006 7.3306 15.5006C7.1506 15.5006 6.9906 15.3762 6.9906 15.1556V12.3919H6.99123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7281 15.1156C13.3731 15.41 12.9381 15.5356 12.4987 15.5356C11.4487 15.5356 10.7043 14.9356 10.7043 13.7463C10.7043 12.7369 11.4893 11.9525 12.5431 11.9525C12.9381 11.9525 13.3725 12.0875 13.6825 12.3925C13.9875 12.6919 13.5475 13.1369 13.2481 12.8725C13.0631 12.6919 12.8031 12.5575 12.5431 12.5575C11.9387 12.5575 11.3543 13.0419 11.3543 13.7463C11.3543 14.4863 11.8437 14.9356 12.4987 14.9356C12.8031 14.9356 13.0631 14.8456 13.2481 14.7106V14.0969H12.4987C12.0537 14.0969 12.0987 13.4862 12.4987 13.4862H13.4981C13.6831 13.4862 13.8525 13.6269 13.8525 13.7819V14.8463C13.8525 14.9356 13.8131 15.02 13.7281 15.1156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.625 17.375H3.75V18H15.625C15.9688 18 16.25 17.7188 16.25 17.375V16.75C16.25 17.0938 15.9688 17.375 15.625 17.375Z",
    fill: "#CAD1D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_832_818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/PNG.6780baf3fcf26753d676feff1506a7eb.svg";
export { ForwardRef as ReactComponent };